import { render, staticRenderFns } from "./AS_VldScheme1.vue?vue&type=template&id=2430f31a&scoped=true&"
import script from "./AS_VldScheme1.vue?vue&type=script&lang=js&"
export * from "./AS_VldScheme1.vue?vue&type=script&lang=js&"
import style0 from "./AS_VldScheme1.vue?vue&type=style&index=0&id=2430f31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2430f31a",
  null
  
)

export default component.exports